import { call, put, takeLatest } from "redux-saga/effects";

import { toast } from "react-toastify";
import { setModal } from "../../utils/global-func";
import {
  avatarListLoad,
  avatarListSuccess,
  createUserFailure,
  createUserLoad,
  createUserSuccess,
  dummyUserListLoad,
  dummyUserListSuccess,
  genderListLoad,
  genderListSuccess,
} from "../slices/createUser.slice";
import {
  avatarListApi,
  createUserApi,
  dummyUserListApi,
  genderListApi,
} from "../Api/api";
import appconstant from "../../themes/appconstant";
import { navigate } from "../../common/navigator";

function* userCreate(action) {
  try {
    const response = yield call(createUserApi, action.payload);
    if (response?.status == 0) {
      toast.success(response?.result?.message);
      // navigate("/Engagementfarming");
      yield put(createUserSuccess(response?.result));
    } else {
      toast.error(response?.result?.message);
      yield put(createUserFailure(response?.result));
    }
  } catch (error) {
    toast.error("Some thing went wrong");
    yield put(createUserFailure());
  }
}

function* avatarSaga(action) {
  try {
    const data = yield call(avatarListApi, action.payload);
    if (data.status === 0) {
      // toast.success(data?.result?.message);
      yield put(avatarListSuccess(data?.result));
    } else {
      toast.error(data?.result?.message);
    }
  } catch (e) {
    toast.error(appconstant.serverError);
  }
}

function* genderListSaga(action) {
  try {
    const data = yield call(genderListApi, action.payload);
    if (data.status === 0) {
      // toast.success(data?.result?.message);
      yield put(genderListSuccess(data?.result));
    } else {
      toast.error(data?.result?.message);
    }
  } catch (e) {
    toast.error(appconstant.serverError);
  }
}

function* dummyUserListSaga(action) {
  try {
    const data = yield call(dummyUserListApi, action.payload);
    if (data.status === 0) {
      // toast.success(data?.result?.message);
      yield put(dummyUserListSuccess(data?.result));
    } else {
      toast.error(data?.result?.message);
    }
  } catch (e) {
    toast.error(appconstant.serverError);
  }
}

function* createUserSaga() {
  yield takeLatest(createUserLoad.type, userCreate);
  yield takeLatest(avatarListLoad.type, avatarSaga);
  yield takeLatest(genderListLoad.type, genderListSaga);
  yield takeLatest(dummyUserListLoad.type, dummyUserListSaga);
}

export default createUserSaga;
